/**
 * React component for rendering a customized legend for a weatherNet graph.
 * @param {Object} props - The props object containing color, datasetName, isPavementTemp.
 * @returns {JSX.Element} - The JSX element representing the graph legend.
 */
import React, { useState } from 'react';

const WeatherForecastLegend = (props) => {
  const { color, datasetName, isPavementTemp } = props;
  return (
    <>
      <li style={{ alignItems: 'center', display: 'flex', flexDirection: 'row', marginLeft: '0.625rem' }}>
        {isPavementTemp ? (
          datasetName &&
          (datasetName + '').length > 0 && (
            <span
              style={{
                borderTop: `0.188rem  ${datasetName === 'Measured' ? 'solid' : 'dashed'} ${color}`,
                paddingTop: '0.125rem',
                display: 'inline-block',
                flexShrink: '0',
                marginRright: '0.625rem',
                width: '1rem',
              }}
            />
          )
        ) : datasetName === 'Forecasted' && !isPavementTemp ? (
          <span
            style={{
              background: color,
              borderColor: color,
              borderWidth: '0.063rem',
              display: 'inline-block',
              flexShrink: '0',
              height: '0.625rem',
              width: '0.625rem',
              position: 'relative', // Needed to position the pseudo-element
              overflow: 'hidden', // Ensures the diagonal line doesn’t go beyond the boundaries
            }}
          >
            <span
              style={{
                content: '""',
                position: 'absolute',
                top: '0',
                left: '50%',
                width: '1px', // Thickness of the diagonal line
                height: '10px', // Length of the diagonal line; increase if needed
                backgroundColor: 'white',
                transform: 'rotate(45deg)', // Creates the diagonal
                transformOrigin: 'center',
              }}
            ></span>
          </span>
        ) : (
          <span
            style={{
              background: color,
              borderColor: color,
              borderWidth: '0.063rem',
              display: 'inline-block',
              flexShrink: '0',
              height: '0.625rem',
              marginRright: '0.625rem',
              width: '0.625rem',
            }}
          ></span>
        )}
        <p
          style={{
            margin: '0rem',
            padding: '0.063rem',
            paddingLeft: '0.25rem',
            fontSize: '0.75rem',
          }}
        >
          {datasetName}
        </p>
      </li>
    </>
  );
};

export default WeatherForecastLegend;
